import configRsySlider from "./settingRsySwiper";
import initSwipers from "../swiper/swiperInit";

const rsyContainer = document.querySelector(".block-slider-rsy.swiper");
const rsyBlock = "block-slider-rsy";

document.addEventListener("DOMContentLoaded", () => {
  if (rsyContainer) {
    initSwipers(rsyBlock, configRsySlider);
  }
});
